module.exports = __webpack_public_path__ + "static/media/skull_front.fa17b949.png";